import { api } from '@/lib/api.js';
import { inFlightDedup } from '@/lib/inFlight.js';

// GET /api/tracon/search?q=… — scans the cached pipeline and returns
// up to 30 hits as { type: 'deal', id, account_id, label, sublabel }.
// In-flight-deduped on the query string so concurrent keystrokes
// share the network call.

// Test data is hidden by default (David 2026-10-31); { showTest: true } asks for it
// (show_test=1), and each hit then carries is_test. Cmd+K never asks.
export function searchPipeline(q, { showTest = false } = {}) {
  const query = (q || '').trim();
  if (query.length < 2) return Promise.resolve({ success: true, results: [] });
  return inFlightDedup(`search:${showTest ? 'test:' : ''}${query}`, () =>
    api.get(`/api/tracon/search?q=${encodeURIComponent(query)}${showTest ? '&show_test=1' : ''}`)
  );
}
